export const AuthorizePermission = {
  // Administrator
  ADMINISTRATOR: 1,

  // Apps
  APP: 100,
  APP_CREATE: 101,
  APP_UPDATE: 102,
  APP_PUBLISH: 103,
  APP_UNPUBLISH: 104,
  APP_DESCRIPTION_UPDATE: 105,
  APP_PRICING_UPDATE: 106,
  APP_PRICING_READ: 111,
  APP_PRICING_UPDATE_KEY_FEATURE: 112,
  APP_READ: 107,
  APP_EXPORT: 108,
  APP_CONFIGURATION_UPDATE: 109,
  APP_GENERAL_INFORMATION_UPDATE: 110,
  APP_CONFIGURATION_UPDATE_PUBLIC: 116,

  // Repository
  REPOSITORY: 200,
  REPOSITORY_CREATE: 201,
  REPOSITORY_DEPLOY: 202,
  REPOSITORY_READ: 203,
  REPOSITORY_DELETE: 204,

  // 300-306 reserved - App Package permissions retired in Wave D (marketplace-package-removal epic). DO NOT reuse these ids.

  // App Instance
  APP_INSTANCE: 400,
  APP_INSTANCE_CREATE: 401,
  APP_INSTANCE_UPDATE: 402,
  APP_INSTANCE_DELETE: 403,
  APP_INSTANCE_DEPLOY: 404,
  APP_INSTANCE_CONTAINER_READ: 405,
  APP_INSTANCE_CONTAINER_DELETE: 406,
  APP_INSTANCE_CONTAINER_START: 407,
  APP_INSTANCE_CONTAINER_STOP: 408,
  APP_INSTANCE_CONTAINER_DEPLOY: 409,
  APP_INSTANCE_CONTAINER_BIND_DOMAIN: 410,
  APP_INSTANCE_CONTAINER_UNBIND_DOMAIN: 411,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_CREATE: 412,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_UPDATE: 413,
  APP_INSTANCE_CONTAINER_IDP_CLIENT_DELETE: 414,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_CREATE: 415,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_UPDATE: 416,
  APP_INSTANCE_CONTAINER_ENVIRONMENT_VARIABLE_DELETE: 417,
  APP_INSTANCE_READ: 418,
  APP_INSTANCE_CONTAINER_UPDATE: 419,

  IDP_CLIENT: 500,
  IDP_CLIENT_CREATE: 501,
  IDP_CLIENT_READ: 502,
  IDP_CLIENT_UPDATE: 503,
  IDP_CLIENT_DELETE: 504,

  // Webhook Registration
  WEBHOOK_REGISTRATION: 600,
  WEBHOOK_REGISTRATION_READ: 601,
  WEBHOOK_REGISTRATION_CREATE: 602,
  WEBHOOK_REGISTRATION_UPDATE: 603,

  // Pipeline (deploy-pipelines Wave 1/2, shipped BE — Wave 3 adds the FE mirror)
  PIPELINE: 700,
  PIPELINE_CREATE: 701,
  PIPELINE_READ: 702,
  PIPELINE_UPDATE: 703,
  PIPELINE_DELETE: 704,
  PIPELINE_RUN: 705,

  // Audit (developer-portal-auditing epic, Wave 1 read API — ADR-0005). AUDIT_READ_OWN (802,
  // publisher-facing owner-scoped read) is Portion B — deliberately NOT added here; it is
  // sequenced second and Wave-2-gated (developer-portal-audit-read-ui spec).
  AUDIT: 800,
  AUDIT_READ: 801,
};
